(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ReportsKarcherController", reportsKarcherController);

  /** @ngInject */
  function reportsKarcherController(
    $scope,
    $state,
    KarcherReportsViewModel,
    layoutActions,
    organizationActions,
    localeFilters,
    $timeout,
    reportExportUtil,
    $translate,
    exportToCsv,
    karcherReportActions,
    weatherKarcherActions,
    $filter,
    DateTime,
    helperService
  ) {
    var vm = this,
      currentDate = new Date();

    vm.isChartVisible = false;
    vm.enableSubPointsInput = false;
    vm.karcherReports = new KarcherReportsViewModel();

    init();

    vm.searchData = function () {
      layoutActions.showLoader();
      vm.karcherReports.refreshKarcherReportsData({
        groupNames: [],
        groupTotal: [],
        groupDada: [],
        total: 0,
        unit: ""
      });

      // Try period is expired
      refreshWeatherHistoryData();

      var data = {
        facilityId: vm.karcherReports.selectedWashFacility,
        timeUnit: vm.karcherReports.selectedTimeFrame,
        since: new DateTime().convertDateForKarcherReports(
          currentDate,
          vm.karcherReports.reportFrom.getTime()
        ),
        to: new DateTime().convertDateForKarcherReports(
          currentDate,
          vm.karcherReports.reportTo.getTime()
        )
      };

      switch (vm.karcherReports.selectedReport) {
        case 1:
          karcherReportActions
            .getRolloverReportTurnover(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 2:
          data.type = "TOTAL";
          getRolloverReportData(data);
          break;
        case 3:
          data.type = "END_CORRECT";
          getRolloverReportData(data);
          break;
        case 4:
          data.type = "EXTERNAL";
          getRolloverReportData(data);
          break;
        case 5:
          data.type = "MANUAL";
          getRolloverReportData(data);
          break;
        case 6:
          data.type = "CANCELED";
          getRolloverReportData(data);
          break;
        case 7:
          data.type = "POWER_FAILURE";
          getRolloverReportData(data);
          break;
        case 8:
          data.bayId = vm.karcherReports.selectedSubPoint;
          karcherReportActions
            .getJetwashReportWorkingHoursPerProgram(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 9:
          karcherReportActions
            .getJetwashReportTurnoverPerBay(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 10:
          data.bayId = vm.karcherReports.selectedSubPoint;
          karcherReportActions
            .getJetwashReportTurnoverPerChannel(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
      }
    };

    vm.changeReportName = function () {
      vm.karcherReports.selectedWashFacility = "";
      vm.karcherReports.selectedSubPoint = "";
    };

    vm.getAvailableBoxes = function (id) {
      vm.karcherReports.getTimezoneForSelectedFacility(vm.karcherReports.washFacilityList.filter(function(facility) {
        return facility.id === id;
      }));
      vm.enableSubPointsInput =
        vm.karcherReports.selectedReport === 8 ||
        vm.karcherReports.selectedReport === 10;
      layoutActions.showLoader();
      vm.karcherReports.selectedWashFacility = id;
      if (vm.enableSubPointsInput) {
        karcherReportActions
          .getWashFacilityBoxesByWashFacilityId(id)
          .then(function (response) {
            vm.karcherReports.refreshSubPointList(response);
            layoutActions.hideLoader();
          });
      } else {
        layoutActions.hideLoader();
      }
    };

    vm.clearWashFacilityInput = function () {
      vm.karcherReports.selectedWashFacility = "";
    };

    vm.exportToCsvReports = function () {
      var fileTitleData = [];
      fileTitleData.push(
        vm.karcherReports.reportNameList.filter(function (item) {
          return item.id === vm.karcherReports.selectedReport;
        })[0].name
      );
      fileTitleData.push(
        vm.karcherReports.washFacilityList.filter(function (item) {
          return item.id === vm.karcherReports.selectedWashFacility;
        })[0].name
      );
      if(vm.enableSubPointsInput) {
        fileTitleData.push(
            $translate.instant(
                vm.karcherReports.subPointList.filter(function (item) {
                  return item.id === vm.karcherReports.selectedSubPoint;
                })[0].name
            )
        );
      }
      fileTitleData.push(
        $filter("date")(vm.karcherReports.reportFrom, "dd-MM-yyyy")
      );
      fileTitleData.push(
        $filter("date")(vm.karcherReports.reportTo, "dd-MM-yyyy")
      );
      // Extend csv report with totals for Karcher brand. I don't want to update reportExportUtils because of R2W reporting
      vm.karcherReports.chartData.data.groupsData.unshift({
        groupValue: "Total",
        values: vm.karcherReports.chartData.data.groupTotal
      });
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant("DATE"),
        vm.karcherReports.chartData.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER
      );

      exportToCsv.export(
        jsonArrayForExport,
        helperService.createFileName(fileTitleData),
        true
      );
    };

    function init() {
      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);
      karcherReportActions.getWashFacilityShortList().then(function (res) {
        vm.karcherReports.refreshWashFacilityList(res);
        layoutActions.hideLoader();
      });
    }

    function refreshWeatherHistoryData() {
      var selectedItem = vm.karcherReports.washFacilityList.filter(function (
          item
        ) {
          return item.id === vm.karcherReports.selectedWashFacility;
        }),
        selectedDateFrom = $filter("date")(
          vm.karcherReports.reportFrom,
          "yyyy-MM-dd"
        ),
        selectedDateTo = $filter("date")(
          vm.karcherReports.reportTo,
          "yyyy-MM-dd"
        );

      weatherKarcherActions
        .getHistoryWeather(
          selectedItem[0].location.latitude,
          selectedItem[0].location.longitude,
          selectedDateFrom,
          selectedDateTo
        )
        .then(function (weatherData) {
          vm.karcherReports.refreshWeatherHistoryData(weatherData);
        });
    }

    function getRolloverReportData(data) {
      karcherReportActions
        .getRolloverReportWashesPerProgram(data)
        .then(function (response) {
          vm.karcherReports.refreshKarcherReportsData(response);
          layoutActions.hideLoader();
        });
    }

    function destroy() {
      vm.karcherReports.destroy();
    }
  }
})();
